/**
 * Shared /api/inf/get_models accessor.
 * Deduplicates in-flight requests and caches briefly so gallery/studio/modals
 * do not stampede Max Processes under polling or multi-mount React trees.
 */

const TTL_MS = 20_000;

/** @type {{ at: number, res: any, promise: Promise<any>|null }} */
let cache = { at: 0, res: null, promise: null };

export function invalidateInfModelsCache() {
  cache = { at: 0, res: null, promise: null };
}

/**
 * @param {Function} hitAxios
 * @param {{ force?: boolean, showLoading?: boolean }} [opts]
 */
export async function fetchInfModels(hitAxios, opts = {}) {
  const force = Boolean(opts.force);
  const showLoading = opts.showLoading === true;
  const now = Date.now();

  if (!force && cache.res && now - cache.at < TTL_MS) {
    return cache.res;
  }
  if (cache.promise) return cache.promise;

  const pending = (async () => {
    try {
      const res = await hitAxios({
        path: "/api/inf/get_models",
        post: false,
        admin: false,
        showLoading,
        showSnackbar: false,
      });
      if (res?.data?.success) {
        cache = { at: Date.now(), res, promise: null };
      }
      return res;
    } finally {
      if (cache.promise === pending) cache.promise = null;
    }
  })();

  cache.promise = pending;
  return pending;
}

/**
 * Lightweight single-model status for generation polling (avoids full list).
 * @param {Function} hitAxios
 * @param {string|number} id
 */
export async function fetchInfModelStatus(hitAxios, id) {
  const n = Number(id);
  if (!Number.isFinite(n) || n < 1) {
    return { data: { success: false, msg: "Invalid model id" } };
  }
  return hitAxios({
    path: `/api/inf/model_status/${n}`,
    post: false,
    admin: false,
    showLoading: false,
    showSnackbar: false,
  });
}
